import { Component, EventEmitter, inject, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorService } from '@portal-core/errors/services/error.service';
import { CancelableEvent } from '@portal-core/general/classes/cancelable-event';
import { LicenseUserStatus } from '@portal-core/license-users/enums/license-user-status.enum';
import { LicenseUser } from '@portal-core/license-users/models/license-user.model';
import { LicenseUsersService } from '@portal-core/license-users/services/license-users.service';
import { SnackBarAutoDismissDurationMS } from '@portal-core/ui/snack-bar/constants/snack-bar-auto-dismiss-duration.constant';
import { LoadingState } from '@portal-core/util/loading-state';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgIf, AsyncPipe } from '@angular/common';
import { ErrorsExpansionPanelComponent } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.component';
import { MatButton } from '@angular/material/button';
import { LoaderComponent } from '@portal-core/general/components/loader/loader.component';

@Component({
    selector: 'mc-user-deactivation-form',
    templateUrl: './user-deactivation-form.component.html',
    styleUrls: ['./user-deactivation-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [ReactiveFormsModule, FormsModule, NgIf, ErrorsExpansionPanelComponent, MatButton, LoaderComponent, AsyncPipe]
})
export class UserDeactivationFormComponent implements OnInit {
  private readonly licenseUsersService = inject(LicenseUsersService);
  private readonly errorService = inject(ErrorService);
  private readonly snackBar = inject(MatSnackBar);
  @Input() licenseUser: LicenseUser;
  @Output() canceled: EventEmitter<void> = new EventEmitter<void>();
  @Output() deactivate: EventEmitter<CancelableEvent> = new EventEmitter<CancelableEvent>();
  @Output() deactivated: EventEmitter<void> = new EventEmitter<void>();

  savingState: LoadingState<string> = new LoadingState<string>();
  showCancelButton: boolean;
  ngOnInit() {
    this.showCancelButton = this.canceled.observers.length > 0;
  }

  onCancelClicked() {
    this.canceled.emit();
  }

  onSubmit() {
    const deactivateEvent = new CancelableEvent();
    this.deactivate.emit(deactivateEvent);

    if (!deactivateEvent.defaultPrevented) {
      this.savingState.update(true);

      this.licenseUsersService.bulkSetLicenseUsersStatus$(this.licenseUser.LicenseId, LicenseUserStatus.Deactivated, [this.licenseUser.Id]).subscribe(() => {
        this.savingState.update(false);

        this.snackBar.open('The user has been deactivated.', 'OK', {
          duration: SnackBarAutoDismissDurationMS
        });

        this.deactivated.emit();
      }, error => {
        this.savingState.update(false, 'Unable to deactivate the user.', this.errorService.getErrorMessages(error));
      });
    }
  }
}
